import React from "react";
import { Reveal } from "../motion";
import SocialIcon from "../SocialIcon";
import { SOCIALS } from "../../lib/social";

const B = process.env.REACT_APP_BACKEND_URL;
const GRID = [
  "cadf37d1-7386-448c-8468-a55f721384bc",
  "3017ea2b-c13d-446f-a5dc-71e1582a92ee",
  "77330fd5-ea3b-4a10-b021-17f588293d07",
  "8e5e013a-3c20-49c6-be0e-fd66b1e722cf",
  "a13eb9e1-459d-49ec-97e4-d37119ab6dee",
  "cadf37d1-7386-448c-8468-a55f721384bc",
].map((id) => `${B}/api/files/sereva/media/${id}.jpeg`);

const SocialSection = () => {
  return (
    <section data-testid="social-section" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="flex flex-wrap gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                data-testid={`social-${s.name}`}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="group flex items-center gap-2 border border-border px-4 py-2.5 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
              >
                <SocialIcon name={s.name} className="w-4 h-4" />
                <span className="text-sm">{s.label}</span>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="grid grid-cols-3 gap-2">
            {GRID.map((src, i) => (
              <a
                key={i}
                href={SOCIALS[0].url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative aspect-square overflow-hidden"
                data-testid={`ig-tile-${i}`}
              >
                <img src={src} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute inset-0 bg-primary/0 group-hover:bg-primary/40 transition-colors flex items-center justify-center">
                  <SocialIcon name="instagram" className="w-7 h-7 text-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                </span>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SocialSection;
